module.exports = "/_next/static/images/1-029c71f8ca46f858027d64b003d1fb2d.jpg";